const LINES = [
    [0, 1, 2], [3, 4, 5], [6, 7, 8],
    [0, 3, 6], [1, 4, 7], [2, 5, 8],
    [0, 4, 8], [2, 4, 6],
];

const winnerOn = (board) => {
    for (const line of LINES) {
        const [a, b, c] = line;
        if (board[a] && board[a] === board[b] && board[a] === board[c]) {
            return { mark: board[a], line };
        }
    }
    return null;
};

const withMark = (board, cell, mark) => board.map((held, i) => (i === cell ? mark : held));

export const otherMark = (mark) => (mark === 'X' ? 'O' : 'X');

export const newGame = () => ({
    board: Array(9).fill(null),
    turn: 'X',
    winner: null,
    over: false,
});

export const play = (game, cell) => {
    if (game.over || game.board[cell]) return game;

    const board = withMark(game.board, cell, game.turn);
    const winner = winnerOn(board);
    const over = Boolean(winner) || board.every(Boolean);

    return { board, turn: over ? game.turn : otherMark(game.turn), winner, over };
};

export const legalMoves = (game) => (game.over
    ? []
    : game.board.flatMap((mark, cell) => (mark ? [] : [cell])));

export const wouldWin = (game, cell, mark) => Boolean(winnerOn(withMark(game.board, cell, mark)));

export const isDraw = (game) => game.over && !game.winner;
